import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { replaceHashValues } from "utils/replaceHashValues";

import Button from "common-components/Buttons";
import Header from "common-components/Header";
import CommonContainer from "common-components/Container";

import { DownloadModal } from "./DownloadModal";

const DownloadReady = ({
  pageContent: { section_title, section_description, Category, buttons },
  handleClick,
  dateOfRequest,
  selectedMDN,
  downloadAvailabilityDeadline,
  modalContent,
  showModal,
  toggleModal,
  requestCategories,
  fileFormat,
  fileSize,
  uniqueTxnId,
  checkForCSRFTokenInfo,
  mtn,
  dateRange
}) => (
  <Container style={{maxWidth:"596px"}}>
    {showModal ? (
      <DownloadModal
        modalContent={modalContent}
        fileFormat={fileFormat}
        showModal={showModal}
        toggleModal={toggleModal}
        fileSize={fileSize}
        uniqueTxnId={uniqueTxnId}
        checkForCSRFTokenInfo={checkForCSRFTokenInfo}
        mtn={mtn}
      />
    ) : null}
    <Header style={{ marginBottom: "16px"}}>{section_title}</Header>
    <Div>
      {convertStringToElements(
        replaceHashValues(section_description, {
          requestDate: dateOfRequest,
          selectedMDN,
          dateRangeSelected:dateRange
        })
      )}
      {requestCategories()}
      <SubDiv>
        {convertStringToElements(
          replaceHashValues(Category[0].category_sub_description, {
            downloadAvailabilityDeadline
          })
        )}
      </SubDiv>
    </Div>
    <Button role="link" onClick={handleClick} background={buttons[0].type}>
      {buttons[0].text}
    </Button>
  </Container>
);

DownloadReady.propTypes = {
  pageContent: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  dateOfRequest: PropTypes.string.isRequired
};

export { DownloadReady };



const Div = styled.div`
  margin-bottom: 48px;

  p,strong{
    font-family:"Verizon NHG DS", Helvetica, Arial, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 300;
    line-height: 36px; /* 112.5% */
    letter-spacing: 0.25px;
  }
  ul {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    letter-spacing: 0.5px;
    margin: 15px 0;
  }
 li {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  }
  p {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
    letter-spacing: 0.5px;
    margin: 15px 0;
  }
  
  p:first-of-type {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 32px;
    color: #6F7171;
  }
`;

const SubDiv = styled.div`
p,strong{
  font-family:"Verizon NHG DS", Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: 36px; /* 112.5% */
  letter-spacing: 0.25px;
 }

p {
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  margin: 15px 0;
}

p:first-of-type {
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  margin: 15px 0;
  color:#000
}
`;
const Container = styled(CommonContainer)`
  margin:  0 !important;
  padding: 64px 20px !important;
  
`;